// Shared formatting for the accounting export builders. All builders are pure
// string functions over the JSON the /accounting endpoints return, so they
// are unit-tested with golden strings and never touch the network.

// 'YYYY-MM-DD' → 'MM/DD/YYYY' (what QuickBooks and ADP expect)
export const mdy = (isoDate) => {
  const [y, m, d] = String(isoDate || '').split('-');
  return y && m && d ? `${m}/${d}/${y}` : '';
};

// integer cents → '1234.56' (never a thousands separator, never a $)
export const dollars = (cents) => (Math.round(Number(cents) || 0) / 100).toFixed(2);

export const csvEscape = (v) => {
  const s = v === null || v === undefined ? '' : String(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
// rows: array of arrays → CRLF-terminated CSV (Excel and Intuit both want CRLF)
export const csvText = (rows) => rows.map(r => r.map(csvEscape).join(',')).join('\r\n') + '\r\n';

// IIF is tab-separated with no quoting at all: strip anything that would
// break a row.
export const iifEscape = (v) => String(v === null || v === undefined ? '' : v).replace(/[\t\r\n]+/g, ' ').trim();
export const tsvText = (rows) => rows.map(r => r.map(iifEscape).join('\t')).join('\r\n') + '\r\n';

// Flatten the /accounting/sales-journal payload into one list of entries,
// each carrying its store, which is what every export renders.
export const flattenEntries = (data) => (data?.stores || []).flatMap(s =>
  (s.entries || []).map(e => ({ ...e, store: s.name, locationId: s.locationId, software: s.profile?.software, taxLabels: s.taxLabels })));
